import React, { useState, useLayoutEffect } from "react"
import classNames from "classnames"
import { Header } from "@mobi/ds"
import analytics from "@mobi/libraries/analytics"
import { useLayout } from "contexts/Layout"
import backToHome, { HOMES_LIST } from "utils/backToHome"
import "./Header.scss"

const openAccountUrl =
  "https://www.itau.com.br/contas/conta-corrente/?utm_source=st&utm_medium=nd&utm_campaign=st-conv-nd-st-nd-all&utm_content=nd-nd-nd-iacnta-nd-pfaqu-MT00001342-rvproduto&utm_term=reneg-x-lp-header&utm_sou=reneg&utm_med=x&utm_camp=lp&utm_cont=header&utm_ter=16"

const menuOpenAccountLink =
  "https://www.itau.com.br/contas/conta-corrente?utm_source=st&utm_medium=nd&utm_campaign=st-conv-nd-st-nd-all&utm_content=nd-nd-nd-iacnta-nd-pfaqu-MT00001342-rvproduto&utm_term=reneg-x-lp-headerparavocebanner&utm_sou=reneg&utm_med=x&utm_camp=lp&utm_cont=headerparavocebanner&utm_ter=36"

const utmsCheckingAccount =
  "&utm_term=reneg-x-lp-headerparavocemenu&utm_sou=reneg&utm_med=x&utm_camp=lp&utm_cont=headerparavocemenu&utm_ter=52"

const HeaderItau = ({ withOutMenu, className, logoUrl }) => {
  const [isHome, setIsHome] = useState(true)
  const { loading } = useLayout()

  useLayoutEffect(() => {
    const _isHome = HOMES_LIST.includes(window?.location?.pathname)
    setIsHome(_isHome)
  }, [])

  const headerClassnames = classNames("container-header", {
    "fixed-header": loading,
    [className]: className,
  })

  return (
    <div className={headerClassnames}>
      <Header
        home={isHome && !withOutMenu}
        prevUrl={backToHome()}
        prevAction={() => {
          analytics.track("segmentButtonClick", {
            name: "VoltarInicio",
            id: "efec2f0c-6434-4632-a5ff-c225752e1dc5",
          })
        }}
        logoLink={
          isHome && !withOutMenu ? "https://www.itau.com.br" : backToHome()
        }
        logoAppUrl="/images/app.png"
        logoUrl={logoUrl}
        mobileInfosApp={{
          title: "Para acessar a sua conta, você precisa baixar o aplicativo.",
          name: "app Itaú",
          description:
            "Um app cada vez mais completo, para você contar com diversos serviços do banco direto do celular.",
          link: "https://vul2.adj.st/home?adj_t=99zccmd_yf47lex&adj_campaign=Site",
          textLink: "baixar app",
        }}
        utmsHeaderMenuCheckingAccount={utmsCheckingAccount}
        handleOpenAccountLink={(ev) => {
          ev.preventDefault()
          window.open(openAccountUrl)
          analytics.track("segmentButtonClick", {
            name: "AbrirConta",
            id: "dd9a5ccb-ac6d-449e-92f6-961e9b24576f",
          })
        }}
        handleMenuOpenAccountLink={(ev) => {
          ev.preventDefault()
          window.open(menuOpenAccountLink)
        }}
        onClickLogo={() => {
          analytics.track("segmentButtonClick", {
            name: "HeaderLogo",
            id: "da898c5c-08bd-48cc-9c3b-a859390ad08f",
          })
        }}
      />
    </div>
  )
}

HeaderItau.defaultProps = {
  withOutMenu: false,
}

export default HeaderItau
